import { ResolveBaseApiUrl } from "../utils/Utility";
import APIService from "./APIService";

const baseUrl = ResolveBaseApiUrl() + "Invoice/";
const invoiceAPIService = new APIService(baseUrl);

export async function GetCustomerInvoices(data) {
  var url = "getcustomerinvoices";
  return await invoiceAPIService.postData(url, data);
}

export async function GetInvoiceDetail(customerid, invoiceid) {
  var url = `getinvoicedetail?customerid=${customerid}&invoiceid=${invoiceid}`;
  return await invoiceAPIService.fetchData(url);
}
